import './style/index';

import _Badge from './badge';

export type { BadgeProps } from './badge';

export const Badge = _Badge;
export default Badge;
